import { Trip, Traveller, SkiPassAgeLevels, SkiPass } from '@/types';

export const calculateTripDuration = (trip: Trip): number => {
  const start = new Date(trip.startDate);
  const end = new Date(trip.endDate);
  return Math.ceil((end.getTime() - start.getTime()) / (1000 * 3600 * 24));
};

export const calculateAge = (dateOfBirth: string | Date): number => {
  const today = new Date();
  const birth = typeof dateOfBirth === 'string' ? new Date(dateOfBirth) : dateOfBirth;
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};

// Berechne das Alter zu einem bestimmten Datum (für Trip-Startdatum)
export const calculateAgeAtDate = (dateOfBirth: string, targetDate: string): number => {
  const birth = new Date(dateOfBirth);
  const target = new Date(targetDate);
  let age = target.getFullYear() - birth.getFullYear();
  const monthDiff = target.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && target.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};

export const getSkiPassBookingStats = (travellers: Traveller[], ageLevels: SkiPassAgeLevels) => {
  const stats = {
    adult: 0,
    youth: 0,
    senior: 0,
    child: 0,
    total: 0
  };

  if (!ageLevels) return stats;

  travellers.forEach(traveller => {
    if (traveller.skiPassType) {
      const age = calculateAge(traveller.dateOfBirth);
      stats.total++;
      if (age <= ageLevels.child.max) stats.child++;
      else if (age >= ageLevels.youth.min && age <= ageLevels.youth.max) stats.youth++;
      else if (age >= ageLevels.senior.min) stats.senior++;
      else stats.adult++;
    }
  });

  return stats;
};

export const getSkiPassPrice = (dateOfBirth: string, ageLevels: SkiPassAgeLevels, skiPass: SkiPass): number => {
  if (!dateOfBirth || !ageLevels) {
    return skiPass.adultPrice;
  }
  const age = calculateAge(dateOfBirth);

  if (ageLevels.child && age >= ageLevels.child.min && age <= ageLevels.child.max) {
    return skiPass.childPrice;
  }
  if (ageLevels.youth && age >= ageLevels.youth.min && age <= ageLevels.youth.max) {
    return skiPass.youthPrice;
  }
  if (ageLevels.senior && age >= ageLevels.senior.min && age <= ageLevels.senior.max) {
    return skiPass.seniorPrice;
  }
  return skiPass.adultPrice;
};

// Ski Pass Preis basierend auf Alter zum Trip-Startdatum (für Billing/Trip-Anmeldungen)
export const getSkiPassPriceAtTripStart = (dateOfBirth: string, tripStartDate: string, ageLevels: SkiPassAgeLevels, skiPass: SkiPass): number => {
  if (!dateOfBirth || !ageLevels) {
    return skiPass.adultPrice;
  }
  
  // Berechne das Alter am Trip-Startdatum, nicht heute!
  const ageAtTripStart = calculateAgeAtDate(dateOfBirth, tripStartDate);

  if (ageLevels.child && ageAtTripStart >= ageLevels.child.min && ageAtTripStart <= ageLevels.child.max) {
    return skiPass.childPrice;
  }
  if (ageLevels.youth && ageAtTripStart >= ageLevels.youth.min && ageAtTripStart <= ageLevels.youth.max) {
    return skiPass.youthPrice;
  }
  if (ageLevels.senior && ageAtTripStart >= ageLevels.senior.min && ageAtTripStart <= ageLevels.senior.max) {
    return skiPass.seniorPrice;
  }
  return skiPass.adultPrice;
};


